<template>
  <ConfirmDialog
    :value="value"
    :title="title"
    icon="star"
    confirm-text="Got it"
    hide-cancel
    @input="$emit('input', $event)"
    @confirm="$emit('input', false)"
  >
    {{ body }}
  </ConfirmDialog>
</template>

<script>
/**
 * "You cannot recommend a sixth product" -- said once, in one place.
 *
 * The same rule is hit from three controls (the Recommended switch, the Active
 * switch on a product that is already recommended, and the Add/Edit form), and
 * a rule explained in three slightly different ways reads as three different
 * rules. So the wording lives here and the screens only say WHICH case they hit.
 *
 * Deliberately not an error: nothing has gone wrong, a limit has been reached.
 * Hence the star (the same glyph the Recommended column uses), the primary tone
 * and a single button.
 */
import ConfirmDialog from "./ConfirmDialog.vue";
import { MAX_RECOMMENDED_PER_TYPE } from "@/app-js/karrofin/constants";

export default {
  name: "KfRecommendedLimitDialog",
  components: { ConfirmDialog },
  props: {
    value: { type: Boolean, default: false },
    /** The full product type, e.g. "Personal Loan". */
    productType: { type: String, default: "" },
    /** The product being acted on. Empty while creating a new one. */
    productName: { type: String, default: "" },
    /**
     * "recommend" -- marking a sixth product recommended.
     * "enable"    -- switching on a disabled product that is already recommended,
     *                which spends a slot because only enabled products count.
     */
    mode: { type: String, default: "recommend" },
  },
  computed: {
    typeLabel() {
      return this.productType || "This product type";
    },
    /* "this product" while creating: there is no name to point at yet. */
    nameLabel() {
      return this.productName || "this product";
    },
    title() {
      return (
        this.typeLabel + " already has " + MAX_RECOMMENDED_PER_TYPE +
        " recommended products"
      );
    },
    rule() {
      return (
        "Only " + MAX_RECOMMENDED_PER_TYPE + " products can be recommended at a " +
        "time in each product type."
      );
    },
    body() {
      if (this.mode === "enable") {
        return (
          this.nameLabel + " is marked recommended, so enabling it would make " +
          (MAX_RECOMMENDED_PER_TYPE + 1) + ". " + this.rule +
          " Un-recommend this one first, or free a slot by un-recommending another."
        );
      }
      return (
        this.rule + " To recommend " + this.nameLabel +
        ", un-recommend one of the current " + MAX_RECOMMENDED_PER_TYPE + " first."
      );
    },
  },
};
</script>
